import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../../common/images/logo.png";
import footertag from "../../common/images/footer-tag.svg";

import { siteLogo, companyName, uniqueID, appName } from "../Settings/Config";
const Parser = require("html-react-parser");
class Footer extends Component {
  constructor(props) {
    super(props);
    const customerID = localStorage.getItem("customerID") ?? "";
    this.state = {
      customerID: customerID,
      staticblock: [],
      footerContent: "",
    };
  }
  componentWillReceiveProps(PropsDt) {
    if (this.state.staticblock !== PropsDt.staticblock) {
      if(PropsDt.staticblock.length>0) {
        this.setState({ staticblock: PropsDt.staticblock }, () => {
          const footerContent = this.state.staticblock.find(
            (item) => item?.slug === "footer"
          );
          this.setState({ footerContent: footerContent });
        });
      }
    }
  }
  createAccount(e) {
    e.preventDefault();
    console.log(this.props, "this.propsthis.propsthis.props");
    if (this.state.customerID !== "") {
      this.props.history.push("/myprofile");
    } else {
      this.props.updateStateValue("loginPopup", true);
    }
  }

  render() {
    var currentDay = new Date();
    var currentyear = currentDay.getFullYear();
    return (
      <div>
        {appName === "sushitei" && (
          <div className="container footer-tag">
            <img src={footertag} alt="Tag" />
          </div>
        )}
        <footer className="fbg">
          <div className="container">
            <div className="footer-wrapper">
              {this.state.footerContent !== "" &&
                Parser(this.state.footerContent?.description ?? "")}
            </div>
            <div className="footer-copyright textcenter">
              © {currentyear} {companyName}., ALL RIGHTS RESERVED
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var staticblock = [];
  if (Object.keys(state.staticblock).length > 0) {
    if (state.staticblock[0].status === "ok") {
      staticblock = state.staticblock[0].result;
    }
  }
  return {
    staticblock: staticblock,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(withRouter(Footer));
